// Before/After gallery data.
// Dates: slide 1 = today − 2 days; each next slide alternates +3 / +4 days further back.
// Override any slide with an explicit `capturedOn: "12 Sep 2026"` string if needed.
const BASE = "/assets/before-after";

export const TEAM_CAPTION = "Photo taken by our team at customer's house";

const fmt = (d) => d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

const autoDate = (i) => {
  let back = 2;
  for (let k = 0; k < i; k++) back += k % 2 === 0 ? 3 : 4;
  const d = new Date();
  d.setDate(d.getDate() - back);
  return fmt(d);
};

export const BEFORE_AFTER = [
  { slug: "bathroom-washbasin", title: "Bathroom Washbasin" },
  { slug: "toilet-commode", title: "Toilet / Commode" },
  { slug: "gas-stove", title: "Stainless Steel Gas Stove" },
  { slug: "kitchen-sink", title: "Kitchen Sink" },
  { slug: "kitchen-chimney", title: "Kitchen Chimney" },
  { slug: "bathroom-tiles", title: "Bathroom Tiles" },
  { slug: "window-glass", title: "Window Glass" },
  { slug: "car-exterior", title: "Car Exterior" },
  { slug: "furniture", title: "Furniture" },
  { slug: "floor-tiles", title: "Floor Tiles" },
].map((x, i) => ({
  ...x,
  src: `${BASE}/${x.slug}.webp`,
  thumb: `${BASE}/${x.slug}-sm.webp`,
  capturedOn: x.capturedOn || autoDate(i),
}));
